export const logoSettings = {
  maxDimension: 2560, //px
  maxFileSize: 1048576, // in bytes === 1 Mb
  allowedTypes: ['image/png', 'image/jpeg', 'image/gif'],
}
